import React, { Suspense, lazy } from 'react';

// Leaflet 大約 40KB，分開打包，用到地圖先載入，唔拖慢首頁第一次載入
const load = () => import('./LeafletMaps');
const LazyDistrictMap = lazy(() => load().then((m) => ({ default: m.DistrictMap })));
const LazySpotMiniMap = lazy(() => load().then((m) => ({ default: m.SpotMiniMap })));
const LazyTripMap = lazy(() => load().then((m) => ({ default: m.TripMap })));

export { DAY_COLORS, dayColor } from './dayColors';

const Placeholder = ({ height }) => (
  <div style={{ height, width: '100%', borderRadius: 14, border: '1.5px solid #e2e8f0', background: '#f1f5f9' }} />
);

const withSuspense = (Comp, defaultHeight) => (props) => (
  <Suspense fallback={<Placeholder height={props.height || defaultHeight} />}>
    <Comp {...props} />
  </Suspense>
);

export const DistrictMap = withSuspense(LazyDistrictMap, 220);
export const SpotMiniMap = withSuspense(LazySpotMiniMap, 180);
export const TripMap = withSuspense(LazyTripMap, 240);
